import React, { FC } from 'react';
import withLocalization from '../../hoc/withLocalization';

import './OfferStep.scss';

interface StepProps {
  title?: string;
}
const OfferStep: FC<StepProps> = (props: StepProps) => {
  const stepTitle = props.title;
  return (
    <>
      <div className="stepe-page-container">
        <span className="title-step-wrapper">{`${stepTitle}`}</span>
      </div>
    </>
  );
};
export default withLocalization(OfferStep);
